// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__1xB7d","heading":"style_heading__VsXiG"};